import Img1 from '../../assets/images/contact/animation/1.png';
import Img2 from '../../assets/images/contact/animation/2.png';
import Img4 from '../../assets/images/contact/animation/4.png';
import Img5 from '../../assets/images/contact/animation/5.png';

const ContactBackgroundImages = [
    {
        img: Img1
    },
    {
        img: Img2
    },
    {
        img: Img4
    },
    {
        img: Img5
    }
]

export default ContactBackgroundImages